// extracted by mini-css-extract-plugin
export var numpadContainer = "_m5-1";
export var phoneButton = "_m5-0";